import './applied_keywords_view.js.coffee';# Added by Script
import './date_filter_view.js.coffee'
import './applied_date_view.js.coffee'
import './text_filter_view.js.coffee'
import './applied_text_view.js.coffee'
import './numeric_filter_view.js.coffee'
import './applied_numeric_view.js.coffee'
import './keywords_filter_view.js.coffee'
import './tags_filter_view.js.coffee'
import './applied_tags_view.js.coffee'
import './boolean_filter_view.js.coffee'
import './applied_boolean_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.FilterGroupView extends Backbone.View
  filterViewClasses:
    'Date':
      selector: Profiling.Dashboard.Filters.DateFilterView
      applied: Profiling.Dashboard.Filters.AppliedDateView
    'Email':
      selector: Profiling.Dashboard.Filters.TextFilterView
      applied: Profiling.Dashboard.Filters.AppliedTextView
    'Text':
      selector: Profiling.Dashboard.Filters.TextFilterView
      applied: Profiling.Dashboard.Filters.AppliedTextView
    'Integer':
      selector: Profiling.Dashboard.Filters.NumericFilterView
      applied: Profiling.Dashboard.Filters.AppliedNumericView
    'FreeText':
      selector: Profiling.Dashboard.Filters.KeywordsFilterView
      applied: Profiling.Dashboard.Filters.AppliedKeywordsView
    'FixedString':
      selector: Profiling.Dashboard.Filters.TagsFilterView
      applied: Profiling.Dashboard.Filters.AppliedTagsView
    'Boolean':
      selector: Profiling.Dashboard.Filters.BooleanFilterView
      applied: Profiling.Dashboard.Filters.AppliedBooleanView

  initialize: ({searchQuery, customAttributes, facets, filtersContainer}) ->
    @filterViews = []
    @appliedViews = []

    customAttributes.forEach (attribute) =>
      viewClasses = @filterViewClasses[attribute.get('attribute_type_name')]
      return unless viewClasses

      tags =  {}
      for tag in attribute.get('tags')
        tags[tag.name] = tag.name

      query = searchQuery.createSubQuery(fieldName: attribute.get('code'))
      parameters =
        searchQuery: query
        title: attribute.get('name')
        tagsByClientCode: tags
        facets: facets
        filtersContainer: filtersContainer
        # Custom-attribute date fields (code prefixed 'ca_') keep the unbounded
        # "All history" option; built-in created/updated stay capped to 3 years.
        allowAllHistory: attribute.get('code').indexOf('ca_') == 0

      @filterViews.push(new viewClasses.selector(parameters))
      @appliedViews.push(new viewClasses.applied(parameters))

  render: ({$appliedEl}) =>
    @$el.empty()
    $appliedEl.empty()

    for view in @filterViews
      $wrapper = $('<div></div>')
      $wrapper.append(view.render().el)
      @$el.append($wrapper)
    for view in @appliedViews
      $appliedEl.append(view.render().el)
    @
